let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("63qTU")).then(() => parcelRequire('aIFSA'));